<template>
  <div class="l-container l-margin-bottom">
    <PageModelModelQuestions
      :per-page="20"
      :model="pageData.model"
      :page-data="pageData"
      :wide-pagination="false"
      when-visible
      :changed-page="pageData.changedPage"
      :is-base-tab="false"
      :is-tablet="isTablet"
      @to-route="(e) => $emit('toRoute', e)"
      @change-data="(e) => $emit('change-data', e)"
    />
  </div>
  <div class="l-container">
    <div id="description-model" class="l-description l-description-grid">
      <PageModelDescriptionModel v-if="showAllComponents" :seo-data="seoData" />
    </div>
    <div class="l-description-grid">
      <ModelSimilar
        v-if="showAllComponents"
        :similar="pageData?.model?.accessories"
        title="Аксессуары"
        type="accessories"
        :show-more-button="false"
        :model-id="pageData.model.id"
        :page-data="pageData"
        :changed-page="pageData.changedPage"
        full-width-mobile
        @change-data="(e) => $emit('change-data', e)"
      />
    </div>
    <div class="l-description-grid">
      <PresetsBasic
        v-if="showAllComponents"
        title="Популярные подборки"
        :items="pageData.presets"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useInteractiveStore } from '~/stores/interactive';
const interactiveStore = useInteractiveStore();
const showAllComponents = computed(() => interactiveStore.isFirstInteractive);
defineEmits(['toRoute', 'change-data']);
defineProps({
  pageData: {
    type: Object as any,
    required: true,
  },
  seoData: {
    type: Object as any,
    required: true,
  },
  isMobile: {
    type: Boolean,
    default: false,
  },
  isTablet: {
    type: Boolean,
    default: false,
  },
  isPresets: {
    type: Boolean,
    default: false,
  },
  isBaseTab: {
    type: Boolean,
    default: false,
  },
});
</script>
<style lang="scss" scoped></style>
